export const overrides = theme => ({})

export const props = {
  color: 'primary',
}
